import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';

import { AppService } from '../shared/services/app.service';
import { InventoryService } from '../inventory/inventory.service';


@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {

  onSaws:any = {
    saw1:null,
    saw2:null,
    forklift:null
  };
  private timer;
  private timerSub: Subscription;

  constructor(
    private _appService: AppService,
    private _invService: InventoryService
  ) {

  }

  ngOnInit() {
    this._appService.hideLoader();
    this.getSaws();
    this.timer = Observable.interval(30000);
    this.timerSub = this.timer.subscribe(x => this.getSaws());
  }

  ngOnDestroy() {
    this.timerSub.unsubscribe();
  }


  private getSaws() {
    this._invService.getOnSaws().subscribe(
      data => {
        this.onSaws = data.onsaws;
        this._appService.hideLoader();
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/welcome/welcome.component.ts